import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import InputBasic from "../ProfilesComp/InputsBasic";
import SignaturesSummary from "../ProfilesComp/SignaturesSummary";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { updateSection } from "../../../store/Profiles/profilesSlice";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const StepSummary = ({ onBack, onNext }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const storedData = useSelector(state => state.profiles.summaryData);

  const [summaryData, setSummaryData] = useState({
    summaryText: "",
    clientName: "",
    clientSignature: "",
    clientDate: "",
    witnessSignature: "",
    witnessDate: "",
    caseManagerSignature: "",
    caseManagerDate: "",
  });

  
  useEffect(() => {
    setSummaryData((prevData) => ({
        ...prevData,
        ...storedData
    }));
  }, [storedData]);

  const updateSummaryData = (data) => {
    setSummaryData((prev) => ({ ...prev, ...data }));
  };

  const handleNextStep = async () => {
    await handleSaveData(); // 🔹 Espera que termine antes de seguir
    onNext()
};

const handleSaveData = async () => {
  dispatch(updateSection({ section: "summaryData", data: { summaryData:summaryData } }));
}


  return (
    <div>
      <Typography variant="h5" gutterBottom>
        {t("Profiles.Summary.Summary")}
      </Typography>
      <Typography variant="h7" gutterBottom>
        {t("Profiles.Summary.Summarizeinformationgatheredfrom")}
      </Typography>

      <InputBasic
        multiline
        rows={6}
        value={summaryData.summaryText}
        onChange={(e) => updateSummaryData({ summaryText: e.target.value })}
      />

      <SignaturesSummary updateSummaryData={updateSummaryData} />

      {/* Botones */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          <Button startIcon={<ArrowBackIcon />} onClick={onBack} variant="outlined">
              {t("common.back")}
          </Button>
          
          <Button endIcon={<ArrowForwardIcon />} onClick={handleNextStep} variant="contained" color="primary">
              Guardar JSON
          </Button>
      </Box>
    </div>
  );
};

export default StepSummary;
